import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import backgroundImg from '../../assets/screens/screen-confirmation-single-ticket.png';
import CardReaderScreen from '../../molecules/CardReaderScreen/CardReaderScreen';
import { TICKET_TYPE_VALUE_TICKET } from '../../constants';
import ConfirmationScreenContent from '../../molecules/ConfirmationScreenContent/ConfirmationScreenContent';
import { getTicketExpirationStringForZones } from '../../time';
import { getTicketPrice } from '../../price';

class ValueTicketConfirmationRC extends PureComponent {
  render() {
    const { currentZone, zones, passengers, remainingFunds } = this.props;
    const valueTicket = {
      zones,
      passengers,
      price: getTicketPrice(TICKET_TYPE_VALUE_TICKET, zones),
      validityEndsAtString: getTicketExpirationStringForZones(zones),
    };
    return (
      <CardReaderScreen backgroundImage={backgroundImg}>
        <ConfirmationScreenContent
          currentZone={currentZone}
          ticketType={TICKET_TYPE_VALUE_TICKET}
          valueTicket={valueTicket}
          remainingFunds={remainingFunds}
        />
      </CardReaderScreen>
    );
  }
}

ValueTicketConfirmationRC.propTypes = {
  currentZone: PropTypes.string.isRequired,
  zones: PropTypes.string.isRequired,
  passengers: PropTypes.number.isRequired,
  remainingFunds: PropTypes.number.isRequired,
};

const mapStateToProps = ({ cardReader }) => ({
  currentZone: cardReader.currentZone,
  zones: cardReader.valueTicket.zones,
  passengers: cardReader.valueTicket.passengers,
  remainingFunds: cardReader.remainingFunds,
});

export default connect(mapStateToProps)(ValueTicketConfirmationRC);
